<template>
    <div class="container mx-auto">
        <div class="flex flex-col">
            <div v-if="loading" role="status" aria-live="polite" class="w-full py-5 text-center text-theme-text">
                {{ translations.integrations.common.loading[lang] }}...
            </div>
            <div v-else-if="existDefinitions" :lang="issue.lang" class="w-full px-2">
                <div class="mb-2 max-h-96 overflow-auto rounded p-2">
                    <p class="mb-2 text-xl font-bold text-theme-text">{{ wordDefinition.word }}</p>
                    <ol class="list-inside list-decimal pl-5">
                        <li v-for="(entry, index) in wordDefinition.entries" :key="index" class="mb-3 text-theme-text">
                            <span class="font-serif italic">{{ entry.category }}. </span>
                            <span>{{ entry.definition }}.</span>
                            <ul v-if="entry.example" class="mt-1 pl-4">
                                <li class="italic text-theme-toolbar-icon">{{ entry.example }}</li>
                            </ul>
                        </li>
                    </ol>
                </div>
            </div>
            <div v-else role="status" aria-live="polite" class="w-full py-4 text-center text-theme-toolbar-icon">
                {{ translations.integrations[integrationSlug].errors['no-results'].message[lang] }}
            </div>
        </div>
    </div>
</template>

<script>
'use strict';

import { mapGetters, mapState } from 'vuex';
import Decrypter from '../../../../src/js/components/lib/Decrypter.js';
import Encrypter from '../../../../src/js/components/lib/Encrypter.js';
import ContentEncryptionService from '../../../../src/js/components/lib/ContentEncryptionService';
import { dictionaryAPI } from '../../../../src/js/communication/integrations';

export default {
    name: 'Dictionary',
    props: {
        text: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            loading: true,
            integrationSlug: 'dictionary',
            wordDefinition: {},
        };
    },
    computed: {
        ...mapState(['integrations', 'translations', 'lang', 'localizations', 'issue']),
        ...mapGetters(['isEpub']),
        existDefinitions() {
            return this.wordDefinition?.entries?.length > 0;
        },
    },
    watch: {
        text: 'handle',
    },
    mounted() {
        this.handle();
    },
    beforeDestroy() {
        this.wordDefinition = {};
    },
    methods: {
        async handle() {
            this.loading = true;
            try {
                const response = await dictionaryAPI.lookup({
                    text: ContentEncryptionService.shouldEncrypt() ? await Encrypter.encryptText(this.text) : this.text,
                    lang: this.issue.lang,
                });

                this.wordDefinition = await this.maybeEncrypt(response);
            } catch (e) {
                console.error('error', e);
            }
            this.loading = false;
        },
        async maybeEncrypt(data) {
            if (ContentEncryptionService.shouldEncrypt()) {
                for (const key in data) {
                    typeof data[key] === 'string'
                        ? (data[key] = await Decrypter.decryptText(data[key]))
                        : await this.maybeEncrypt(data[key]);
                }
            }
            return data;
        },
    },
};
</script>
